import React from 'react'
import { CANVAS_COLORS } from '../../utils/tokens/canvas'
import { getCornerRadiusPercent, type MobileCanvasState } from './mobileBoard'

const mobileBoardShellStyle = {
  backgroundColor: CANVAS_COLORS.background.board,
  backgroundImage:
    'radial-gradient(circle at top left, rgba(255,255,255,0.75), transparent 42%), linear-gradient(180deg, rgba(255,255,255,0.55), rgba(253,252,249,0.92))',
  boxShadow: '0 24px 56px rgba(61,59,54,0.12)',
} satisfies React.CSSProperties

interface MobileBoardPreviewProps {
  state: MobileCanvasState
  emptyMessage?: string
  className?: string
  shellStyle?: React.CSSProperties
}

export const MobileBoardPreview: React.FC<MobileBoardPreviewProps> = ({
  state,
  emptyMessage = 'Share a few of your favorite images.',
  className,
  shellStyle,
}) => {
  return (
    <div
      className={`relative aspect-[4/3] w-full overflow-hidden rounded-[16px] border border-[rgba(61,59,54,0.08)] ${className ?? ''}`.trim()}
      style={{
        ...mobileBoardShellStyle,
        ...shellStyle,
      }}
    >
      {state.elements.length === 0 ? (
        <div className="flex h-full w-full items-center justify-center px-6 text-center">
          <span className="font-serif text-fs-500 italic text-ink-500">
            {emptyMessage}
          </span>
        </div>
      ) : (
        state.elements.map((element) => {
          const left = (element.left / state.width) * 100
          const top = (element.top / state.height) * 100
          const width = (element.width / state.width) * 100
          const height = (element.height / state.height) * 100

          return (
            <div
              key={element.id}
              className="absolute overflow-hidden border border-[rgba(61,59,54,0.08)] bg-stone-200"
              style={{
                left: `${left}%`,
                top: `${top}%`,
                width: `${width}%`,
                height: `${height}%`,
                borderRadius: getCornerRadiusPercent(state.cornerStyle),
                boxShadow: '0 10px 24px rgba(61,59,54,0.08)',
              }}
            >
              <img
                src={element.src}
                alt=""
                className="h-full w-full object-cover"
                draggable={false}
              />
            </div>
          )
        })
      )}
    </div>
  )
}

export default MobileBoardPreview
